/**
* Local Storage Module
* Wrapper for interfacing w/ HTML5 localStorage. (De-)serializes values for storage, scopes keys to 'SCM' namespace.
*/
var SCM = SCM || {};
SCM.Utilities = SCM.Utilities || {};

SCM.Utilities.LocalStorage = (function(){
  'use strict';

  var _namespace = 'SCM';
  var _storageAdapter = window.localStorage;

  /**
  * Returns module API
  * @returns {object}
  */
    return {
        getItem: getItem,
        setItem: setItem,
        removeItem: removeItem
    };
	

  /**
  * Serializes and stores in storageAdapter
  *
  * @param {string} key - The storage Key
  * @param {object} data - The storage Value
  * @param {object} adapter - The localStorage adapter
  */
  function setItem(key, value, adapter){
    var adapter = adapter ? adapter : _storageAdapter;
    adapter.setItem(_namespace + '.' + key, JSON.stringify(value));
  }

  /**
  * Retrieves and de-serializes from storageAdapter
  *
  * @param {string} key - The storage Key
  * @param {object} adapter - The localStorage adapter
  */
  function getItem(key, adapter){
    var adapter = adapter ? adapter : _storageAdapter;
    var item = adapter.getItem(_namespace+'.'+key);
    return JSON.parse(item);
  }

  /**
  * Removes the object from storageAdapter
  *
  * @param {string} key - The session storage Key to retrive
  */
  function removeItem(key, adapter){
    var adapter = adapter ? adapter : _storageAdapter;
    adapter.removeItem(_namespace+'.'+key);
  } 

})();